import { Construction } from 'lucide-react';

interface Props {
  name: string;
  description?: string;
}

/**
 * Placeholder genérico para módulos em construção.
 * Exibe nome do módulo + mensagem amigável.
 */
export function ModuloEmConstrucao({ name, description }: Props) {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      minHeight: '60vh', padding: 40, textAlign: 'center',
    }}>
      <div style={{
        width: 80, height: 80, borderRadius: 20,
        background: 'linear-gradient(135deg, #eef2ff, #e0e7ff)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        marginBottom: 24,
      }}>
        <Construction size={36} style={{ color: '#6366f1' }} />
      </div>
      <h1 style={{ fontSize: '1.5rem', fontWeight: 700, color: 'var(--text-main)', margin: '0 0 8px' }}>
        {name}
      </h1>
      <p style={{ fontSize: '0.9rem', color: 'var(--text-muted)', maxWidth: 400, lineHeight: 1.6 }}>
        {description || 'Este modulo esta em construcao e sera disponibilizado em breve.'}
      </p>
      <div style={{
        marginTop: 24, padding: '8px 20px', borderRadius: 20,
        background: 'var(--bg-card)', border: '1px solid var(--border-color)',
        fontSize: '0.78rem', color: 'var(--text-muted)', fontWeight: 600,
      }}>
        Em desenvolvimento
      </div>
    </div>
  );
}
